﻿jQuery.fn.extend({
	enableButton: function () {
		return this.each(function () {
			this.disabled = false;
			this.style.cursor = 'pointer';
			this.classList.remove('disabled');
		});
	},
	disableButton: function () {
		return this.each(function () {
			this.disabled = true;
			this.style.cursor = 'not-allowed';
			this.classList.add('disabled');
		});
    },
    ActivateTabButton: function () {
		return this.each(function () {			
            this.classList.remove('btn-secondary');
            this.classList.add('btn-success');            
						var currentNodeId = this.id;
            var dataParentValue = this.dataset.tabparent;
            var dataSelector = '[data-tabparent]';    
            var siblings = Array.from(document.querySelectorAll(dataSelector))
																.filter(node => node.dataset.tabparent === dataParentValue && node.id !== currentNodeId);
						if (!siblings) return;
            siblings.forEach(node => {
                if (!node) return;
                node.classList.remove('btn-success');
                node.classList.add('btn-secondary');
            });
		});
	}	
});